/* StreetKings product catalog, pulled from Shopify.
   Shared by the homepage (/) and the setup page (studio-setup.html).
   v = variant ID (cart links), img = product photo, id = product handle. */
var STORE = "";   // same store: Shopify URLs are relative
var CDN = "https://cdn.shopify.com/s/files/1/0595/9155/7183/files/";

var BADGES = [
  ["SRT Hellcat","srt-hellcat-head-flow-series-grill-badge",145.99,41906024480831,"SRT_Hellcat_Badge_Challenger_W_0600c3a0-cd8f-4ced-975c-a625c551c687.png?v=1777485359"],
  ["392 Scatpack Head","392-scatpack-head-flow-series-grill-badge",145.99,41906016583743,"392_Scat_Head.png?v=1777485400"],
  ["392 Scatpack","392-scatpack-floq-series-grill-badge",145.99,41906004525119,"392_Bee_Badge_Challenger_W_6912a30c-9cac-4d32-881b-95f0abdd20e8.png?v=1777485436"],
  ["345 R/T","345r-t-flow-series-grill-badge-copy",135.99,41905888165951,"345_RT_Badge_Charger_8cf0ec48-6e67-4267-8b7c-84c1bceed073.png?v=1777485558"],
  ["SRT 8Ball","srt-8ball-flow-series-grill-badge",145.99,41906113282111,"SRT8_Badge_Chrysler_6e5f602c-1133-46e2-9a56-3df687d34e5b.png?v=1777485039"],
  ["SXT","sxt-flow-series-grill-badge",135.99,41906093129791,"SXT_Badge_Challenger_W_1bd4b721-ecb5-4050-a3cb-61cdf9c1dfe0.png?v=1777485259"],
  ["SRT","srt-flow-series-grill-badge",135.99,41905986240575,"SRT_Badge_Charger_702eaeed-2703-4f2e-a202-b9eb33889dde.png?v=1777485470"],
  ["SRT Scatpack Head","srt-scatpack-head-flow-series-grill-badge",145.99,41905967661119,"SRT_Scat_Badge_Challenger_W_a6f0ee9b-6943-433f-a9b3-0cdbbcd0b128.png?v=1777485496"],
  ["SRT Scatpack","345r-t-flow-series-grill-badge-copy-copy",145.99,41905891803199,"SRT_Bee_Badge_Charger_d9a94b31-7730-462a-8a79-a0e01606f4f8.png?v=1777485525"],
  ["TRX","trx-flow-series-grill-badge",145.99,41906111545407,"TRX_Dyno_Badge_TRX_9aaf47d7-fb08-46a1-9936-852e4b29f77e.png?v=1777485115"],
  ["Hemi","hemi-flow-series-grill-badge",135.99,41906097356863,"HEMI_Badge_Challenger_W_37316937-3f46-4bb7-a3dd-d43c37b165b5.png?v=1777485214"],
  ["SRT300","srt300-flow-series-grill-badge",135.99,41906152833087,"SRT_300_Badge_Chrysler_bdfbdeff-5b0e-43cd-910c-28c7f63e00d9.png?v=1777485007"],
  ["Daytona","daytona-flow-series-grill-badge",135.99,41906099290175,"DAYTONA_Badge_Charger_f4fb4e08-029a-4b31-91b7-719926299eff.png?v=1777485144"],
  ["345","345-flow-series-grill-badge",135.99,41906098110527,"345_Badge_Challenger_W_0d6d53fa-cc13-436a-97de-d537b02b2d1f.png?v=1777485182"],
  ["392","392-flow-series-grill-badge",135.99,41906051317823,"392_Badge_Charger_72b81b21-c43b-43af-b547-ff20f6486cd9.png?v=1777485292"],
  ["300","300-flow-series-grill-badge-copy",135.99,41906046271551,"300_Badge_Chrysler.png?v=1777485810"],
  ["300 Hellcat","300-hellcat-head-flow-series-grill-badge",145.99,41906031460415,"300_Hellcat_Badge_Badge_Chrysler_9689edf9-7400-4278-b63d-e83846da05ad.png?v=1777485328"],
].map(([trim,handle,price,v,img]) => ({id:handle,name:trim+" Flow Series Badge",trim,handle,price,v,img}));

var opt = (name,handle,price,v,img) => ({id:handle,name,handle,price,v,img});
// Parts that only fit one body style
var slimOnly = o => Object.assign(o,{body:"slim"});
var wideOnly = o => Object.assign(o,{body:"wide"});
var BODIES = [{id:"wide",label:"Widebody"},{id:"slim",label:"Slim Body"}];

var WHEELS = [
  opt("OE Style Redeye Beadlock","demon-170-rim",1399.99,43965060612159,"Unknown-21.png?v=1790363211"),
  opt("OE Style Demon 5 Spoke Beadlock","demon-170-rim-copy",1399.99,43965143482431,"Unknown-4.png?v=1790296655"),
  opt("OE Style Devils Beadlock","demon-170-rim-copy-copy",1399.99,43965162422335,"Unknown-6.png?v=1790297318"),
  opt("OE Style Open 5 Spoke Beadlock","demon-170-rim-copy-copy-copy-copy",1399.99,43967276908607,"Unknown-8.png?v=1790359167"),
  opt("OE Cat Style Beadlock","demon-170-rim-copy-copy-copy",1399.99,43967336054847,"Unknown-17.png?v=1790362665"),
  opt("OE 5 Spoke Style Beadlock","demon-170-rim-copy-copy-copy-copy-copy",1399.99,43967349030975,"Unknown-38.png?v=1790450471"),
  opt("OE Reaper Style Beadlock","kk",1399.99,43967606128703,"Unknown-24.png?v=1790374967"),
  opt("OE 170 Style Beadlock","kk-copy",1399.99,43967708201023,"Unknown-27.png?v=1790375831"),
];
var INTERIOR = [
  opt("Classic Black RGB SRT Airbag Cover","classic-black-rgb-srt-airbag-cover",249.99,41909446377535,"387d7be9-e0b8-488e-8bb5-ef40868f5f92.png?v=1789765783"),
];

var CARS = [
  { id:"charger", name:"Charger", years:"2015–2023", collection:"charger-products", bodies:BODIES, photo:SKA+"cars-charger.jpg",
    hero:"Unknown-48.png?v=1790547945",
    cats:[
      {id:"hood",label:"Hood",options:[
        opt("Redeye Style Aluminum Hood","charger-redeye-hood-aluminum",649.99,41911376052287,"Unknown-112.png?v=1791055934"),
        opt("Redeye Style Carbon Fiber Hood","charger-redeye-hood-carbon-fiber",1099.99,41911384571967,"Unknown-113.png?v=1791056839"),
        opt("Redeye Style Forged Carbon Hood","2015-2023-charger-redeye-style-carbon-fiber-hood-copy",1099.99,44051799146559,"Unknown-107.png?v=1791053051"),
        opt("Redeye Supercharger Window Carbon Hood","oe-redeye-window-cut-out-carbon-hood",2299.99,43992359043135,"Unknown-48.png?v=1790547945"),
        opt("Redeye Supercharger Window Forged Carbon Hood","2015-2023-forged-carbon-fiber-dodge-charger-redeye-style-supercharger-window-hood-copy",2299.99,44005567561791,"Unknown-102.png?v=1791047686"),
        opt("Redeye Supercharger Window Fiberglass Hood","2015-2023-charger-redeye-style-supercharger-window-fiber-glass-hood",1999.99,44072079589439,"Unknown-154.png?v=1791388177"),
        opt("Demon Style Hood","2015-2023-charger-demon-style-aluminum-hood",2299.99,44063169642559,"Unknown-129.png?v=1791240293"),
        opt("Demon Style Supercharger Window Carbon Hood","2015-2023-charger-demon-style-supercharger-window-carbon-fiber-hood",2499.99,44063189925951,"Unknown-132.png?v=1791243030"),
      ]},
      {id:"headlights",label:"Headlights",options:[
        opt("Jewel Eye RGB Flow Series Headlights","2015-2023-dodge-charger-jewel-eye-rgb-flow-series-headlights",1899.99,43895493099583,"Unknown-59.png?v=1790628530"),
        opt("Multicolor Flow Series Headlights","dodge-charger-multicolor-flowseries-headlights-2015-2023",1399.99,43926402138175,"df2d0ef8-55cd-4591-8ea1-2606aa766af0.png?v=1790021572"),
        opt("Flow Series DRL Headlight Kit","flow-series-drl-headlight-kit",315.99,41913663160383,"Unknown-67.png?v=1790639879"),
      ]},
      {id:"badge",label:"Grill Badge",options:BADGES},
      {id:"tail",label:"Tail Lights",options:[
        opt("KingFlow RGB Pre-Built Tail Lights","2015-2023-dodge-charger-kingflow-rgb-pre-built-tail-lights",1899.99,43895840243775,"Unknown-142.png?v=1791325463"),
      ]},
      {id:"lip",label:"Front Lip",options:[
        slimOnly(opt("SlimBody Front Lip","charger-slimbody-front-lip",114.99,42476704104511,"Unknown-92.png?v=1790858177")),
      ]},
      {id:"fenders",label:"Fenders",options:[
        wideOnly(opt("Widebody Carbon Fiber Fenders","carbon-fiber-fenders",1599.99,44009526755391,"Unknown-70.png?v=1790726359")),
        wideOnly(opt("Widebody Forged Carbon Fenders","charger-widebody-forged-carbon-fiber-fenders",1599.99,44018049384511,"Unknown-76.png?v=1790791506")),
      ]},
      {id:"wheels",label:"Wheels",options:WHEELS},
      {id:"interior",label:"Interior",options:INTERIOR},
    ]},
  { id:"challenger", name:"Challenger", years:"2008–2023", collection:"challenger-products", bodies:BODIES, photo:SKA+"cars-challenger.jpg",
    hero:"Unknown-58.png?v=1790626353",
    cats:[
      {id:"hood",label:"Hood",options:[
        opt("Redeye Style Carbon Fiber Hood","challenger-redeye-hood-carbon-fiber",999.99,41911371300927,"Unknown-156.png?v=1791397846"),
        opt("Redeye Style Dual Scoop Hood","challenger-redeye-hood-aluminum",649.99,41911371726911,"Unknown-98.png?v=1790984380"),
        opt("Supercharger Window Hood","challenger-hellcat-see-through-hood-2008-2023",1699.99,43938812395583,"Unknown-58.png?v=1790626353"),
      ]},
      {id:"badge",label:"Grill Badge",options:BADGES},
      {id:"tail",label:"Tail Lights",options:[
        opt("KingFlow RGB Pre-Built Tail Lights","2015-23-challenger-kingflow-rgb-pre-built-tail-lights",1899.99,44068958830655,"Unknown-135.png?v=1791317225"),
      ]},
      {id:"diffuser",label:"Diffuser",options:[
        opt("Challenger Rear Diffuser","challenger-diffuser",199.99,44072099119167,"Unknown-160.png?v=1791401180"),
      ]},
      {id:"wheels",label:"Wheels",options:WHEELS},
      {id:"interior",label:"Interior",options:INTERIOR},
    ]},
  { id:"300", name:"Chrysler 300", years:"2011–2023", collection:"300-products", photo:SKA+"cars-chrysler-300.jpg",
    hero:"Unknown-97.png?v=1790984180",
    cats:[
      {id:"hood",label:"Hood",options:[
        opt("Redeye Style Hood","chrystler-300-redeye-style-aluminum-hood",699.99,42462661148735,"Unknown-151.png?v=1791330080"),
        opt("Redeye Style Aluminum Hood","2011-2023-chrysler-300-supercharger-window-hood-copy",1399.99,44052123942975,"Unknown-119.png?v=1791061104"),
        opt("Supercharger Window Hood","chrysler-300-hellcat-style-carbon-fiber-hood-w-glass-window-2011-2023",1399.99,43930531397695,"Unknown-97.png?v=1790984180"),
      ]},
      {id:"badge",label:"Grill Badge",options:BADGES},
      {id:"wheels",label:"Wheels",options:WHEELS},
      {id:"interior",label:"Interior",options:INTERIOR},
    ]},
  { id:"durango", name:"Durango", years:"2014–2023", collection:"durango", photo:SKA+"cars-durango.jpg",
    cats:[
      {id:"kit",label:"Body Kit",options:[
        opt("Durango Widebody Kit","2014-2023-durango-widebody-kit",0,44076987121727,"Unknown-161.png?v=1791485326"),
      ]},
    ]},
  { id:"cherokee", name:"Cherokee", years:"2010–2022", collection:"cherokee", photo:SKA+"cars-cherokee.jpg",
    cats:[
      {id:"hood",label:"Hood",options:[
        opt("Redeye Style Carbon Fiber Supercharger Window Hood","2010-2022-cherokee-redeye-style-carbon-supercharger-window-hood",0,44085121679423,"Unknown-162.png?v=1791662574"),
        opt("Redeye Style Forged Carbon Supercharger Window Hood","2010-2022-cherokee-redeye-style-forged-carbon-supercharger-window-hood",0,44085121712191,"Unknown-163.png?v=1791662608"),
        opt("Redeye Style Fiberglass Supercharger Window Hood","2010-2022-cherokee-redeye-style-fiberglass-supercharger-window-hood",0,44085122007103,"Unknown-164.png?v=1791663969"),
      ]},
    ]},
  { id:"trx", name:"Ram TRX", years:"2021–2024", shopHref:"/search?q=TRX&type=product", photo:SKA+"cars-trx.jpg",
    cats:[
      {id:"badge",label:"Grill Badge",options:[
        ...BADGES.filter(b => b.handle === "trx-flow-series-grill-badge"),
        opt("BIG TRX Flow Series Grill Badge","trx-flow-series-grill-badge-1",145.99,44096893026367,"Screenshot_2026-10-12_at_1.55.54_PM.png?v=1791827765"),
      ]},
      {id:"headlights",label:"Headlights",options:[
        opt("TRX Flow Series Headlights","trx-flow-series-headlights",0,44096901873727,"DodgeRam1500TRXRGBWDRLBoards_2019-2024_2_png.webp?v=1791828468"),
      ]},
    ]},
];


/* The part categories a car shows for one body style
   (hides parts that only fit the other body, and empty categories). */
function carCats(car, body){
  return car.cats
    .map(c => Object.assign({}, c, { options: c.options.filter(o => !o.body || !body || o.body === body) }))
    .filter(c => c.options.length);
}
/* Each body style gets its own photos in the Build Studio */
function studioKey(car, body){ return car.bodies && body ? car.id + "-" + body : car.id; }
function bodyLabel(car, body){ const b = car.bodies && car.bodies.find(x => x.id === body); return b ? b.label : ""; }

/* Homepage "Fan favorites" (picked by StreetKings) */
var FAVORITES = [
  opt("SRT Hellcat Flow Series Grill Badge","srt-hellcat-head-flow-series-grill-badge",145.99,41906024480831,"SRT_Hellcat_Badge_Challenger_W_0600c3a0-cd8f-4ced-975c-a625c551c687.png?v=1777485359"),
  opt("Charger Redeye Supercharger Window Carbon Fiber Hood","oe-redeye-window-cut-out-carbon-hood",2299.99,43992359043135,"Unknown-48.png?v=1790547945"),
  opt("SKC Performance OE Style Redeye Beadlock","demon-170-rim",1399.99,43965060612159,"Unknown-21.png?v=1790363211"),
  opt("Challenger Supercharger Window Hood","challenger-hellcat-see-through-hood-2008-2023",1699.99,43938812395583,"Unknown-58.png?v=1790626353"),
  opt("Charger Flow Series DRL Headlight Kit","flow-series-drl-headlight-kit",315.99,41913663160383,"Unknown-67.png?v=1790639879"),
  opt("Chrysler 300 Supercharger Window Hood","chrysler-300-hellcat-style-carbon-fiber-hood-w-glass-window-2011-2023",1399.99,43930531397695,"Unknown-97.png?v=1790984180"),
  opt("Charger Redeye Supercharger Window Forged Carbon Hood","2015-2023-forged-carbon-fiber-dodge-charger-redeye-style-supercharger-window-hood-copy",2299.99,44005567561791,"Unknown-102.png?v=1791047686"),
  opt("Charger Demon Style Supercharger Window Carbon Hood","2015-2023-charger-demon-style-supercharger-window-carbon-fiber-hood",2499.99,44063189925951,"Unknown-132.png?v=1791243030"),
  opt("Charger Redeye Supercharger Window Fiberglass Hood","2015-2023-charger-redeye-style-supercharger-window-fiber-glass-hood",1999.99,44072079589439,"Unknown-154.png?v=1791388177"),
];

/* Homepage "Shop by upgrade" tiles */
var CATEGORY_TILES = [
  {label:"Hoods", href:"/collections/hoods", img:"Unknown-48.png?v=1790547945"},
  {label:"Lighting", href:"/collections/lighting", img:"Unknown-142.png?v=1791325463"},
  {label:"Wheels", href:"/collections/skc-performance", img:"Unknown-21.png?v=1790363211"},
  {label:"Body & Aero", href:"/collections/body-aero", img:"Unknown-70.png?v=1790726359"},
];

/* Homepage "Flow Series" lineup tiles (all the RGB lighting) */
var LINEUP = [
  {label:"Grill Badges", note:"17 styles", href:"/collections/grill-badges", img:"SRT_Hellcat_Badge_Challenger_W_0600c3a0-cd8f-4ced-975c-a625c551c687.png?v=1777485359"},
  {label:"Headlights", note:"RGB headlights and DRL kit", href:"/collections/lighting", img:"Unknown-59.png?v=1790628530"},
  {label:"Tail Lights", note:"KingFlow RGB, Charger and Challenger", href:"/collections/lighting", img:"Unknown-142.png?v=1791325463"},
  {label:"Interior", note:"RGB SRT airbag cover", href:"/products/classic-black-rgb-srt-airbag-cover", img:"387d7be9-e0b8-488e-8bb5-ef40868f5f92.png?v=1789765783"},
];

/* Where a product link goes. In this preview it's our own product page;
   once the site is on Shopify this becomes "/products/" + handle. */
function productUrl(handle){ return "/products/" + encodeURIComponent(handle); }

/* Accessories that aren't in the builder */
var ACCESSORIES = [
  opt("Replacement Wiring Kit for Flow Series Badges","wiring-kit-flowseries-badge",25.99,41975587733567,"201f9bc6-11b9-45ca-8da8-b0ed1cc7dbdb.png?v=1789948377"),
];

/* Every product the site knows about, by handle (for the product page) */
function findProduct(handle){
  const all = [...BADGES, ...WHEELS, ...INTERIOR, ...ACCESSORIES, ...FAVORITES, ...CARS.flatMap(c => c.cats.flatMap(k => k.options))];
  return all.find(o => o.id === handle || o.handle === handle) || null;
}
/* Which cars / bodies / part types a product fits, from the builder data */
function fitmentFor(handle){
  const out = [];
  CARS.forEach(car => {
    const bodies = car.bodies ? car.bodies.map(b => b.id) : [null];
    bodies.forEach(body => {
      carCats(car, body).forEach(cat => {
        if(cat.options.some(o => o.id === handle)) out.push({car, body, cat});
      });
    });
  });
  return out;
}

/* Collection page links. In this preview they go to our own collection page;
   on Shopify they become "/collections/<handle>". */
function collectionUrl(handle){ return "/collections/" + (handle ? encodeURIComponent(handle) : "all"); }
function carUrl(carId, body){ return "/collections/all?car=" + encodeURIComponent(carId) + (body ? "&body=" + body : ""); }
/* Shopify collection for each builder part type, and the reverse */
var CAT_COLLECTION = { hood:"hoods", headlights:"lighting", tail:"lighting", badge:"grill-badges", wheels:"skc-performance", lip:"body-aero", fenders:"body-aero", diffuser:"body-aero", kit:"body-aero", interior:null };
